import { combineReducers, Reducer } from 'redux';
import user from './user';
import student from './student';
import groups from './groups';
import {storyInfoReducers as stories, selectedStoryReducers as selectedStory} from './stories';
import { UserData } from '../models/User';
import { StudentData } from '../models/Student';
import { GroupData } from '../models/Group';
import { StoryInfo, SelectedStory } from '../models/Story';

export interface RootState {
	user: UserData;
	student: StudentData;
	groups: GroupData[];
	stories: StoryInfo[];
	selectedStory: SelectedStory;
}

export default combineReducers<RootState>({
	user,
	student,
	groups,
	stories,
	selectedStory
});


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/src/reducers/index.ts